import {
  IonAvatar,
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonChip,
  IonCol,
  IonIcon,
  IonRow,
} from "@ionic/react";
import "./PathCard.css";
import VehicleDefault from "../assets/image/vehicleDefault.png";
import {
  checkmarkCircleOutline,
  locationOutline,
  notificationsOutline,
} from "ionicons/icons";
interface PathCardProps {
  vehicleName: string;
  vehiclePicture?: string;
  trailerName: string;
  trailerId?: string;
  vehicleCode: string;
  trailerCode?: string;
  vehicleId: string;
  travelDate: string;
  travelHour: string;
  numberOfDamage: number;
  withDamageButton?: boolean;
  setReportDamageModal?: (value: boolean) => void;
}

const PathCard: React.FC<PathCardProps> = ({
  vehicleName,
  vehiclePicture,
  vehicleCode,
  trailerCode,
  trailerName,
  trailerId,
  vehicleId,
  travelDate,
  travelHour,
  numberOfDamage,
  withDamageButton = false,
  setReportDamageModal,
}) => {
  return (
    <IonCard className="PathCard">
      <IonCardHeader className="PathCard-header">
        <IonRow className="ion-align-items-center">
          {travelDate}
          <IonCol>
            <IonChip color="light">{travelHour}</IonChip>
          </IonCol>
        </IonRow>
        <IonRow className="PathCard-row_gap">
          <IonAvatar>
            <img src={VehicleDefault} className="PathCard-image" alt={``} />
          </IonAvatar>

          <IonCol>
            <IonRow>{vehicleName}</IonRow>
            <IonRow>{vehicleId}</IonRow>
            <IonRow>{vehicleCode}</IonRow>
          </IonCol>
          {trailerName && trailerId ? (
            <IonCol>
              <IonRow>{trailerName}</IonRow>
              <IonRow>{trailerId}</IonRow>
              <IonRow>{trailerCode}</IonRow>
            </IonCol>
          ) : null}
        </IonRow>
      </IonCardHeader>

      <IonCardContent>
        {withDamageButton ? (
          <IonButton
            color={"danger"}
            expand="block"
            onClick={() => {
              if (setReportDamageModal) {
                setReportDamageModal(true);
              }
            }}
          >
            <IonIcon icon={notificationsOutline} slot="start" />
            Signaler un dommage
          </IonButton>
        ) : (
          <IonRow className="PathCard-content ion-align-items-center">
            <>
              <IonIcon
                icon={checkmarkCircleOutline}
                color="primary"
                size=""
                className="PathCard-icon"
              />
              {numberOfDamage} dommage signalé{" "}
            </>
          </IonRow>
        )}
      </IonCardContent>
    </IonCard>
  );
};

export default PathCard;
